import { ClientTable } from "components/clients/ClientTable";
import { connect } from "react-redux";
import { deleteClient, fetchClientPage, fetchClientFormState } from "store/clients/actions";
import { setFilters } from "store/clients/actions";

const mapStateToProps = ({ clients }) => ({
  filters: clients.filters,
  values: clients.values,
  loading: clients.isFetching,
  pagination: clients.pagination,
  shortClients: clients.shortValues,
  formState: clients.formState,
});

const mapDispatchToProps = {
  setFilters: setFilters,
  fetchClients: fetchClientPage,
  fetchClientFormState,
  remove: deleteClient
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientTable);
